var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('br'),_c('v-btn-toggle',{attrs:{"background-color":"white","borderless":""}},[_c('v-btn',{staticStyle:{"padding":"15%"},attrs:{"x-large":"","height":_vm.height}},[_vm._v(" "+_vm._s(_vm.info[_vm.jsonTitle])+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }